import { motion } from 'framer-motion';
import { useHistory } from 'react-router';
import { DBetIconSvg, DJackIconSvg, TnCIconSvg } from './HomepageIcons';
import controllerIcon from '../../constants/icons/controller_icon.png';
import arrowNextIcon from '../../constants/icons/arrow_next_icon.png';

const HomepageGamesList = () => {
  // redirect
  const history = useHistory();

  const onButtonClick = (text: string) => {
    if (text === 'DJack') {
      history.push('/djacklobby');
    } else if (text === 'TnC') {
      history.push('/tnclobby');
    } else if (text === 'DBet') {
      history.push('/dbetgame/2');
    }
  };

  // motion
  const info = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delay: 2.5,
        duration: 1
      }
    }
  };
  return (
    <motion.div
      key="homepageGamesListWrapper"
      variants={info}
      initial="hidden"
      animate="visible"
    >
      <div className="cardTitle">
        <img
          src={controllerIcon}
          alt="controllerIcon"
          className="homepageGamesListTitleIcon"
        />
        Games List
      </div>
      <div className="homepageGamesListContainer">
        <div className="homepageGamesListItem">
          <div className="homepageGamesListItemIconWrapper">
            <DJackIconSvg white />
          </div>
          <div className="homepageGamesListItemTextWrapper">
            <h4>Dice Jack</h4>
            <p>Try to collect maximum points by rolling the dice.</p>
          </div>
          <button type="button" onClick={() => onButtonClick('DJack')}>
            <img src={arrowNextIcon} alt="arrowNextIcon" />
          </button>
        </div>
        <div className="homepageGamesListItem">
          <div className="homepageGamesListItemIconWrapper">
            <TnCIconSvg white />
          </div>
          <div className="homepageGamesListItemTextWrapper">
            <h4>Throw n Catch</h4>
            <p>Throw and catch the ball with correct timing.</p>
          </div>
          <button type="button" onClick={() => onButtonClick('TnC')}>
            <img src={arrowNextIcon} alt="arrowNextIcon" />
          </button>
        </div>
        <div className="homepageGamesListItem">
          <div className="homepageGamesListItemIconWrapper">
            <DBetIconSvg white />
          </div>
          <div className="homepageGamesListItemTextWrapper">
            <h4>Dice Bet</h4>
            <p>Try to guess the value of next dice roll.</p>
          </div>
          <button type="button" onClick={() => onButtonClick('DBet')}>
            <img src={arrowNextIcon} alt="arrowNextIcon" />
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default HomepageGamesList;
